import cn from 'classnames';
import React from 'react';

import { Accordion, Typography } from '@sravni/react-design-system';

import type { IFAQMeta } from '../../../../interfaces/metadata';

import styles from './faq.module.scss';

interface IProps {
  data: IFAQMeta;
  className?: string;
}

export const FAQ: React.FC<IProps> = ({ data, className }) => {
  const {
    serviceResponseData: { title, items },
  } = data;

  if (!items?.length) return null;

  return (
    <div className={cn(styles.wrapper, className)}>
      <Typography.Heading level={3} className="h-mb-24">
        {title}
      </Typography.Heading>
      <Accordion separator="divider">
        {items.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Accordion.Item title={item.question} key={`faq-${i}`} className={styles.item}>
            <span dangerouslySetInnerHTML={{ __html: item.answer }} />
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};
